export abstract class DemoAccountIdentifiers {
  static readonly demoAxNumbers: string[] = ["0000000", "9999997", "9999998"];
  static readonly demoAccountIds: number[] = [31018, 32071, 32072];
  static readonly censoredWarehouseAccountIds: number[] = [31018, 32071];
  static readonly censoredCiscoAccountIds: number[] = [31018];
}

export function isDemoAccountByAccountId(accountId: number): boolean {
  return DemoAccountIdentifiers.demoAccountIds.includes(accountId);
}

/**
 * Sets or clears the demoData localStorage flag based on whether the account is a demo account.
 * This should be called when the user profile is loaded to handle the case
 * where a user logs in directly to a demo account (rather than impersonating).
 * Also clears the flag for non-demo accounts to handle the case where a user
 * previously logged into a demo account and then logs into a real account
 * without explicitly logging out (e.g., session timeout, closing browser).
 */
export function syncDemoDataFlag(accountId: number): void {
  if (isDemoAccountByAccountId(accountId)) {
    localStorage.setItem("demoData", "true");
  } else {
    localStorage.removeItem("demoData");
  }
}
